/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { CompanyAssociatedDataNuclearAndGasData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataAndMetaInformationNuclearAndGasData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataMetaInformation } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportJobInfo } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportLatestRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * NuclearAndGasDataControllerApi - axios parameter creator
 */
export const NuclearAndGasDataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyNuclearAndGasData: async (companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getAllCompanyNuclearAndGasData', 'companyId', companyId)
            const localVarPath = `/data/nuclear-and-gas/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (showOnlyActive !== undefined) {
                localVarQueryParameter['showOnlyActive'] = showOnlyActive;
            }

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedNuclearAndGasData: async (dataId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('getCompanyAssociatedNuclearAndGasData', 'dataId', dataId)
            const localVarPath = `/data/nuclear-and-gas/{dataId}`
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedNuclearAndGasDataByDimensions: async (reportingPeriod: string, companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingPeriod' is not null or undefined
            assertParamExists('getCompanyAssociatedNuclearAndGasDataByDimensions', 'reportingPeriod', reportingPeriod)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyAssociatedNuclearAndGasDataByDimensions', 'companyId', companyId)
            const localVarPath = `/data/nuclear-and-gas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedNuclearAndGasData: async (identifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('getLatestAvailableCompanyAssociatedNuclearAndGasData', 'identifier', identifier)
            const localVarPath = `/data/nuclear-and-gas/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyAssociatedDataNuclearAndGasData} companyAssociatedDataNuclearAndGasData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedNuclearAndGasData: async (companyAssociatedDataNuclearAndGasData: CompanyAssociatedDataNuclearAndGasData, bypassQa?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAssociatedDataNuclearAndGasData' is not null or undefined
            assertParamExists('postCompanyAssociatedNuclearAndGasData', 'companyAssociatedDataNuclearAndGasData', companyAssociatedDataNuclearAndGasData)
            const localVarPath = `/data/nuclear-and-gas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (bypassQa !== undefined) {
                localVarQueryParameter['bypassQa'] = bypassQa;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyAssociatedDataNuclearAndGasData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedNuclearAndGasDataByDimensions: async (exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportRequestData' is not null or undefined
            assertParamExists('postExportJobCompanyAssociatedNuclearAndGasDataByDimensions', 'exportRequestData', exportRequestData)
            const localVarPath = `/data/nuclear-and-gas/export-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions: async (exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportLatestRequestData' is not null or undefined
            assertParamExists('postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions', 'exportLatestRequestData', exportLatestRequestData)
            const localVarPath = `/data/nuclear-and-gas/export-latest-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportLatestRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NuclearAndGasDataControllerApi - functional programming interface
 */
export const NuclearAndGasDataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NuclearAndGasDataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompanyNuclearAndGasData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataAndMetaInformationNuclearAndGasData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompanyNuclearAndGasData(companyId, showOnlyActive, reportingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NuclearAndGasDataControllerApi.getAllCompanyNuclearAndGasData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedNuclearAndGasData(dataId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataNuclearAndGasData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedNuclearAndGasData(dataId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NuclearAndGasDataControllerApi.getCompanyAssociatedNuclearAndGasData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedNuclearAndGasDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataNuclearAndGasData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedNuclearAndGasDataByDimensions(reportingPeriod, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NuclearAndGasDataControllerApi.getCompanyAssociatedNuclearAndGasDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestAvailableCompanyAssociatedNuclearAndGasData(identifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataNuclearAndGasData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestAvailableCompanyAssociatedNuclearAndGasData(identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NuclearAndGasDataControllerApi.getLatestAvailableCompanyAssociatedNuclearAndGasData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanyAssociatedDataNuclearAndGasData} companyAssociatedDataNuclearAndGasData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompanyAssociatedNuclearAndGasData(companyAssociatedDataNuclearAndGasData: CompanyAssociatedDataNuclearAndGasData, bypassQa?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataMetaInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyAssociatedNuclearAndGasData(companyAssociatedDataNuclearAndGasData, bypassQa, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NuclearAndGasDataControllerApi.postCompanyAssociatedNuclearAndGasData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportJobCompanyAssociatedNuclearAndGasDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportJobCompanyAssociatedNuclearAndGasDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NuclearAndGasDataControllerApi.postExportJobCompanyAssociatedNuclearAndGasDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NuclearAndGasDataControllerApi.postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NuclearAndGasDataControllerApi - factory interface
 */
export const NuclearAndGasDataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NuclearAndGasDataControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyNuclearAndGasData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationNuclearAndGasData>> {
            return localVarFp.getAllCompanyNuclearAndGasData(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedNuclearAndGasData(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataNuclearAndGasData> {
            return localVarFp.getCompanyAssociatedNuclearAndGasData(dataId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedNuclearAndGasDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataNuclearAndGasData> {
            return localVarFp.getCompanyAssociatedNuclearAndGasDataByDimensions(reportingPeriod, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedNuclearAndGasData(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataNuclearAndGasData> {
            return localVarFp.getLatestAvailableCompanyAssociatedNuclearAndGasData(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyAssociatedDataNuclearAndGasData} companyAssociatedDataNuclearAndGasData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedNuclearAndGasData(companyAssociatedDataNuclearAndGasData: CompanyAssociatedDataNuclearAndGasData, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation> {
            return localVarFp.postCompanyAssociatedNuclearAndGasData(companyAssociatedDataNuclearAndGasData, bypassQa, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedNuclearAndGasDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportJobCompanyAssociatedNuclearAndGasDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NuclearAndGasDataControllerApi - interface
 */
export interface NuclearAndGasDataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCompanyNuclearAndGasData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationNuclearAndGasData>>;

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedNuclearAndGasData(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataNuclearAndGasData>;

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedNuclearAndGasDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataNuclearAndGasData>;

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestAvailableCompanyAssociatedNuclearAndGasData(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataNuclearAndGasData>;

    /**
     * 
     * @param {CompanyAssociatedDataNuclearAndGasData} companyAssociatedDataNuclearAndGasData 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAssociatedNuclearAndGasData(companyAssociatedDataNuclearAndGasData: CompanyAssociatedDataNuclearAndGasData, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation>;

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportJobCompanyAssociatedNuclearAndGasDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

}

/**
 * NuclearAndGasDataControllerApi - object-oriented interface
 */
export class NuclearAndGasDataControllerApi extends BaseAPI implements NuclearAndGasDataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllCompanyNuclearAndGasData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig) {
        return NuclearAndGasDataControllerApiFp(this.configuration).getAllCompanyNuclearAndGasData(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedNuclearAndGasData(dataId: string, options?: RawAxiosRequestConfig) {
        return NuclearAndGasDataControllerApiFp(this.configuration).getCompanyAssociatedNuclearAndGasData(dataId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedNuclearAndGasDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig) {
        return NuclearAndGasDataControllerApiFp(this.configuration).getCompanyAssociatedNuclearAndGasDataByDimensions(reportingPeriod, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestAvailableCompanyAssociatedNuclearAndGasData(identifier: string, options?: RawAxiosRequestConfig) {
        return NuclearAndGasDataControllerApiFp(this.configuration).getLatestAvailableCompanyAssociatedNuclearAndGasData(identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyAssociatedDataNuclearAndGasData} companyAssociatedDataNuclearAndGasData 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCompanyAssociatedNuclearAndGasData(companyAssociatedDataNuclearAndGasData: CompanyAssociatedDataNuclearAndGasData, bypassQa?: boolean, options?: RawAxiosRequestConfig) {
        return NuclearAndGasDataControllerApiFp(this.configuration).postCompanyAssociatedNuclearAndGasData(companyAssociatedDataNuclearAndGasData, bypassQa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportJobCompanyAssociatedNuclearAndGasDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return NuclearAndGasDataControllerApiFp(this.configuration).postExportJobCompanyAssociatedNuclearAndGasDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return NuclearAndGasDataControllerApiFp(this.configuration).postExportLatestJobCompanyAssociatedNuclearAndGasDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }
}

